
import { getUser } from "@/utils/getUser.js";
import { Toast } from "vant";

// 401拦截
const resp401 = {
  /**
   * 响应数据之前做点什么
   * @param response 响应对象
   * @param options 应用配置 包含: {router, i18n, store, Toast}
   * @returns {*}
   */
  onFulfilled(response, options) {
    const {router} = options
    if (response.code === 401) {
      getUser()
    }
    return response
  },
  /**
   * 响应出错时执行
   * @param error 错误对象
   * @param options 应用配置 包含: {router, i18n, store, Toast}
   * @returns {Promise<never>}
   */
  onRejected(error, options) {
    // console.log(options)
    const {router} = options
    const {response} = error
    if (response&&response.status === 401) {
      getUser()
    }
    return Promise.reject(error)
  }
}

const resp403 = {
  onFulfilled(response, options) {
    if (response.code === 403) {
      Toast('请求被拒绝')
    }
    return response
  },
  onRejected(error, options) {
    const {response} = error
    console.log(error,options)
    if (response&&response.status=== 403) {
      Toast('请求被拒绝')
    }
    return Promise.reject(error)
  }
}

const reqCommon = {
  /**
   * 发送请求之前做些什么
   * @param config axios config
   * @param options 应用配置 包含: {router, i18n, store, Toast}
   * @returns {*}
   */
  onFulfilled(config, options) {
    // console.log(xsrfCookieName,222323232,Cookie.get(xsrfCookieName),options)

    // const {router} = options
    // const {url, xsrfCookieName} = config
    // console.log(config)
    // if (url.indexOf('getNumber') === -1 && xsrfCookieName && !Cookie.get(xsrfCookieName)) {
    //   console.log("打印当前urlurlurl",url)
    //   Toast('认证 token 已过期，请重新登录')
    // } if(url.indexOf('getNumber')>-1){
    //   Cookie.remove(xsrfCookieName)
    // }
    return config
  },
  /**
   * 请求出错时做点什么
   * @param error 错误对象
   * @param options 应用配置 包含: {router, i18n, store, Toast}
   * @returns {Promise<never>}
   */
  onRejected(error, options) {
    // const {Toast} = options
    // Toast.fail(error.Toast)
    return Promise.reject(error)
  }
}

export default {
  request: [reqCommon], // 请求拦截
  response: [resp401, resp403] // 响应拦截
}



// WEBPACK FOOTER //
// ./src/utils/axios-interceptors.js